import { render, staticRenderFns } from "./AdminHotels.vue?vue&type=template&id=8d71f244&"
import script from "./AdminHotels.vue?vue&type=script&lang=js&"
export * from "./AdminHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports